export const languages = [
  'de',
  'es',
  'fr',
  'it',
  'no',
  'pl',
  'pt',
];
